<template>
	<div id="configBool">
		<el-form ref="form" :rules="rules" :model="form" label-width="120px" inline>
			<!-- 数据长度 -->
			<el-form-item class="formItem" label="数据长度" prop="byteLen">1字节</el-form-item>
			<!-- 取值范围 -->
			<el-form-item class="formItem" label="取值范围" prop="bounds">
				<div class="formInput">
					<span class="formInputSpan">1</span>
					<span class="betweenInput">~</span>
					<el-input
						class="formInputSmall"
						size="small"
						placeholder="如 开"
						v-model="form.bounds.trueValue"
					></el-input>
				</div>
				<div class="formInput">
					<span class="formInputSpan">0</span>
					<span class="betweenInput">~</span>
					<el-input
						class="formInputSmall"
						size="small"
						placeholder="如 关闭"
						v-model="form.bounds.falseValue"
					></el-input>
				</div>
			</el-form-item>
			<!-- 读写类型 -->
			<el-form-item class="formItem" label="读写类型" prop="rw">
				<el-radio-group v-model="form.rw">
					<el-radio :label="3">读写</el-radio>
					<el-radio :label="1">只读</el-radio>
				</el-radio-group>
			</el-form-item>
			<!-- 数据处理 -->
			<el-form-item class="formItem" label="数据处理" prop="dataProcess">
				<el-tooltip
					effect="dark"
					content="仅展示：数据仅在设备详情页的参数列表中显示即可，上报并更新此参数。仅统计：数据上报后需要存贮作为后续统计图使用。统计并展示：设备详情页的参数列表中只显示当前最新的状态，其余存储作为历史。数据不处理：默认，即不做业务逻辑处理"
					placement="top-start"
				>
					<el-select v-model="form.dataProcess">
						<el-option
							v-for="item in dataProcessList"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-tooltip>
			</el-form-item>
			<!-- 描述 -->
			<el-form-item class="formItem" label="描述" prop="description">
				<el-input
					placeholder="请输入"
					type="textarea"
					class="formInput"
					size="small"
					v-model="form.description"
				></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "configBool",
	data() {
		return {
			rules: {
				byteLen: [
					{
						required: true,
						message: "请填写数据长度",
						trigger: "change",
					},
				],
				bounds: [
					{
						required: true,
						message: "请填写取值范围",
						trigger: "change",
					},
				],
				rw: [
					{
						required: true,
						message: "请选择读写类型",
						trigger: "change",
					},
				],
				dataProcess: [
					{
						required: true,
						message: "请选择数据处理方式",
						trigger: "change",
					},
				],
			},
			dataProcessList: [
				{
					value: 1,
					label: "不处理",
				},
				{
					value: 2,
					label: "统计",
				},
				{
					value: 3,
					label: "展示",
				},
				{
					value: 4,
					label: "展示与统计",
				},
			],
			form: {
				dataProcess: 1,
				byteLen: "1",
				bounds: {
					falseValue: "",
					trueValue: "",
				},
				description: "",
				rw: "",
			},
		};
	},
	methods: {
		assignForm: function (form) {
			form.bounds = JSON.parse(form.bounds);
			if (form.dataProcess == null) {
				form.dataProcess = 1;
			}
			for (let i in this.form) {
				this.form[i] = form[i];
			}
		},
		handleSubmit: function () {
			if (!this.form.bounds.trueValue || !this.form.bounds.falseValue) {
				this.$message.error("请填写完整取值范围");
				return false;
			}
			let result;
			this.$refs.form.validate((valid) => {
				if (valid) {
					result = Object.assign({}, this.form);
					result.bounds = JSON.stringify(result.bounds);
				} else {
					result = false;
				}
			});
			return result;
		},
		close: function () {
			this.$refs.form.resetFields();
		},
	},
};
</script>

<style scoped>
.formInput {
	width: 200px;
}
.formItem {
	width: 45%;
}
.formInputSmall {
	width: 130px;
}
.betweenInput {
	display: inline-block;
	width: 30px;
	text-align: center;
	font-size: 20px;
}
.formInputSpan {
	display: inline-block;
	text-align: center;
	width: 40px;
}
</style>